import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{background:'rgba(10,3,0,.99)',borderTop:'1px solid rgba(255,184,0,.16)',padding:'3.5rem 1.5rem 1.8rem'}}>
      <div style={{maxWidth:1300,margin:'0 auto'}}>
        <div style={{display:'grid',gridTemplateColumns:'2fr 1fr 1fr 1fr',gap:'2.2rem',marginBottom:'2.2rem'}}>
          <div>
            <Link to="/" style={{display:'flex',alignItems:'center',gap:'.5rem',textDecoration:'none'}}>
              <span className="om-glow" style={{fontSize:'1.7rem'}}>ॐ</span>
              <span style={{fontFamily:"'Cinzel Decorative',serif",fontSize:'1.05rem',fontWeight:700,background:'linear-gradient(135deg,#FFE082,#FF6B00)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent'}}>CosmicHindu</span>
            </Link>
            <p style={{fontSize:'.84rem',color:'rgba(255,224,130,.42)',lineHeight:1.7,fontStyle:'italic',marginTop:'.8rem'}}>
              A sacred space for seekers — exploring the rich spiritual heritage of Sanatana Dharma and offering authentic divine products with love and devotion.
            </p>
            <div style={{marginTop:'1rem'}}>
              <div style={{fontFamily:"'Cinzel',serif",fontSize:'.67rem',letterSpacing:'.25em',textTransform:'uppercase',color:'#FF6B00',marginBottom:'.6rem'}}>We Accept</div>
              <div style={{display:'flex',gap:'.5rem',flexWrap:'wrap'}}>
                {['🇮🇳 UPI','GPay','PhonePe','Paytm','💳 Visa','Mastercard','RuPay'].map(p=>(
                  <span key={p} style={{background:'rgba(255,255,255,.06)',border:'1px solid rgba(255,184,0,.18)',borderRadius:4,padding:'.3rem .6rem',fontFamily:"'Cinzel',serif",fontSize:'.58rem',color:'rgba(255,224,130,.55)'}}>{p}</span>
                ))}
              </div>
            </div>
          </div>
          <div>
            <h4 style={{fontFamily:"'Cinzel',serif",fontSize:'.67rem',letterSpacing:'.25em',textTransform:'uppercase',color:'#FF6B00',marginBottom:'.9rem'}}>Sacred Shop</h4>
            <ul style={{listStyle:'none',padding:0}}>
              {['God Idols','Rudraksha','Karungali','Spiritual Jewellery','Astro Stones','Pooja Essentials'].map(c=>(
                <li key={c} style={{marginBottom:'.52rem'}}>
                  <Link to="/shop" style={{fontSize:'.82rem',color:'rgba(255,224,130,.48)',textDecoration:'none'}}>{c}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 style={{fontFamily:"'Cinzel',serif",fontSize:'.67rem',letterSpacing:'.25em',textTransform:'uppercase',color:'#FF6B00',marginBottom:'.9rem'}}>Wisdom</h4>
            <ul style={{listStyle:'none',padding:0}}>
              {['Mantras & Shlokas','Puja Guides','Vedas & Upanishads','Bhagavad Gita','Festivals Calendar','Yoga & Sadhana'].map(w=>(
                <li key={w} style={{marginBottom:'.52rem'}}>
                  <span style={{fontSize:'.82rem',color:'rgba(255,224,130,.48)',cursor:'default'}}>{w}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 style={{fontFamily:"'Cinzel',serif",fontSize:'.67rem',letterSpacing:'.25em',textTransform:'uppercase',color:'#FF6B00',marginBottom:'.9rem'}}>Help</h4>
            <ul style={{listStyle:'none',padding:0}}>
              {[['About Us','/about'],['Contact Us','/contact'],['Track Order','/account'],['Shipping Policy','/about'],['Returns & Refunds','/about'],['Privacy Policy','/about']].map(([label,to])=>(
                <li key={label} style={{marginBottom:'.52rem'}}>
                  <Link to={to} style={{fontSize:'.82rem',color:'rgba(255,224,130,.48)',textDecoration:'none'}}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div style={{borderTop:'1px solid rgba(255,184,0,.1)',paddingTop:'1.6rem',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'.7rem'}}>
          <p style={{fontFamily:"'Cinzel',serif",fontSize:'.72rem',letterSpacing:'.07em',color:'rgba(255,224,130,.28)'}}>
            © 2025 CosmicHindu.com — All Rights Reserved | Jai Shri Ram 🙏
          </p>
          <div style={{display:'flex',gap:'.6rem'}}>
            {['📷','▶','f','𝕏','📌'].map(s=>(
              <span key={s} style={{width:30,height:30,border:'1px solid rgba(255,184,0,.22)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.78rem',color:'rgba(255,224,130,.45)',cursor:'pointer'}}>{s}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
